import { useFeatureFlags } from 'v2/shared/hooks/use-feature-flags'
import { isEmbedMode } from 'v2/shared/utils/embed-session'

// Whether the SSE playground transport is active. Every transport fork reads this, never the
// raw flag: embed stays on PubNub, and a half-switched transport receives nothing.
export const usePlaygroundStreamTransport = (): boolean =>
  isStreamTransportActive(useFeatureFlags().playgroundStreamTransportEnabled, isEmbedMode())

export const isStreamTransportActive = (flagEnabled: boolean, embed: boolean): boolean =>
  flagEnabled && !embed
